export const tabSizes = {
  sm: {
    padding: '9px 32px',
  },
  lg: {
    padding: '12px 32px',
  },
};
